import { Form } from 'antd';
import React, { FunctionComponent, useState } from 'react';
import { FlowContentBody, QuestionWrapper } from '../../styles/Containers';
import { TextInput } from '../../styles/TextInput';
import { BodySM, HeroTitle } from '../../styles/Typography';
import { LayoutActions } from './LayoutActions';

export type CoverageEmployerLayoutConfig = {
  title: string;
  body: string[];
  inputLabel: string;
  inputPlaceholder: string;
  primaryButtonTitle: string;
};

type Props = CoverageEmployerLayoutConfig & {
  prefill?: string;
  onPressPrimaryButton: (employer: string) => void;
};

export const CoverageEmployerLayout: FunctionComponent<Props> = (props) => {
  const [employer, setEmployer] = useState(props.prefill ?? '');
  const canSubmit = employer.trim().length > 0;

  function onPrimaryPress(): void {
    if (!canSubmit) return;
    props.onPressPrimaryButton(employer.trim());
  }

  return (
    <Form>
      <QuestionWrapper>
        <FlowContentBody>
          <HeroTitle data-test="surveyQuestion">{props.title}</HeroTitle>
          {props.body.map((line, index) => (
            <BodySM key={index}>{line}</BodySM>
          ))}
          <Form.Item>
            <TextInput
              type="text"
              autoComplete="organization"
              value={employer}
              placeholder={props.inputPlaceholder}
              aria-label={props.inputLabel}
              data-testid="coverage-employer-input"
              onChange={({ target: { value } }) => setEmployer(value)}
            />
          </Form.Item>
        </FlowContentBody>
        <LayoutActions
          primaryButtonTitle={props.primaryButtonTitle}
          onPressPrimaryButton={onPrimaryPress}
          primaryButtonDisabled={!canSubmit}
        />
      </QuestionWrapper>
    </Form>
  );
};
